import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import TextField from '../../components/common/TextField';
import { formatTime, getAlertMessageFunction } from '../../common/Util';
import { HtmIDFindCertify, setStep } from './findByPasswordSlice';

const Step4 = ({ stepHandler }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('findPassword');
  const { t: tCommon } = useTranslation('common');
  const [time, setTime] = useState(120);
  const { idInfo } = useSelector(state => state.findByPassword);

  const [code, setCode] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prevTime => prevTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleCodeChange = e => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setCode(value);
  };

  const clickConfirm = async () => {
    const alertMessage = getAlertMessageFunction();
    if (!code) {
      alertMessage(t('alertMessage01'));
      return;
    }
    let data = {
      htmMCd: idInfo.htmMCd,
      htmSCd: idInfo.htmSCd,
      htmSMSKey2: code,
    };
    try {
      const response = await dispatch(HtmIDFindCertify(data)).unwrap();
      const { resultCode } = response;
      if (resultCode == 'OK') {
        dispatch(setStep(5));
      } else {
        alertMessage(t('alertMessage02'));
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Typography variant="subtitleBold">{t('step4.title')}</Typography>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
          {t('step4.description')}
        </Typography>
      </div>
      {/*  */}
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <TextField
          variant="login"
          placeholder={t('step4.placeholder.code')}
          value={code}
          onChange={handleCodeChange}
        />
        {/* <div className="captionMedium" style={{ width: '100%', textAlign: 'right' }}>
          {formatTime(time)}
        </div> */}
      </div>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        <Button value={tCommon('confirm')} fullWidth onClick={clickConfirm} />
        <Button color="sub" value={tCommon('cancel2')} fullWidth onClick={() => stepHandler(2)} />
      </div>
    </>
  );
};

export default Step4;
